import { Component, OnInit, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { LOGO } from '../../core/models/logo.enum';
import { LoginChallengeDataService } from '../../core/services/login-challenge-data.service';
import { DomainDataService } from '../../core/services/domain-data.service';
import { LoginPageApiService } from '../../core/services/login-page-api.service';
import { RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'o-auth',
    templateUrl: './oauth.component.html',
    styleUrls: ['oauth.component.scss'],
    imports: [NgIf, RouterOutlet]
})
export class OauthComponent implements OnInit {
  public clientLogo = LOGO.CLIENT;
  public loginChallenge = '';
  public domainName = '';
  public disableGreytHrLogo = true;
  private destroyRef = inject(DestroyRef);

  constructor(
    private _loginChallengeDataService: LoginChallengeDataService,
    private _domainDataService: DomainDataService,
    private _loginPageApiService: LoginPageApiService,
    private _cdRef: ChangeDetectorRef
  ) { }

  public ngOnInit() {
    this.loginChallenge = this._loginChallengeDataService.getLoginChallenge();
    this.domainName = this._domainDataService.getDomain();
    this._loginChallengeDataService.loginChallengeSource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this._setLoginCallenge.bind(this));
    this._domainDataService.domainSource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this._setDomainName.bind(this));
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.disableGreytHrLogo = res && res.disableGreytHrLogo ? res.disableGreytHrLogo : false;
      });
  }
  private _setLoginCallenge(value): void {
    this.loginChallenge = value;
  }
  private _setDomainName(value): void {
    this.domainName = value;
  }
}
